export default __webpack_public_path__ + "static/media/element_spec_55.fadfb9f5.webp";